
import "/app/src/components/SpaceDetailModal/index.module.less?modules";
export default {"modal": `modal-yG5V4_Y7`}
